/**
 * Download lip-sync result video via fetch + blob (same as My Creations page).
 * @param {string} url
 * @param {string} [fileName]
 * @returns {Promise<void>}
 */
export function downloadLipSyncVideoBlob(url, fileName = "video.mp4") {
  if (!url) return Promise.reject(new Error("missing url"));

  return fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const objectUrl = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.style.display = "none";
      anchor.href = objectUrl;
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(anchor);
    });
}
